import * as actions from "./2step.authentication.actions";
import update from "immutability-helper";

let initialState = {
  AuthKey: {
    fetching: false,
    fetched: false,
    value: null,
  },
  AuthQr: {
    fetching: false,
    fetched: false,
    value: null,
  },
  Identity: "",
};

const twoStepAuthenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_USER_AUTHENTICATION_KEY_REQUEST:
      return update(state, {
        AuthKey: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });
    case actions.GET_USER_AUTHENTICATION_KEY_SUCCESS:
      return update(state, {
        AuthKey: {
          fetching: { $set: false },
          fetched: { $set: true },
          value: { $set: action.response },
        },
      });
    case actions.GET_USER_AUTHENTICATION_QR_REQUEST:
      return update(state, {
        AuthQr: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });
    case actions.GET_USER_AUTHENTICATION_QR_SUCCESS:
      return update(state, {
        AuthQr: {
          fetching: { $set: false },
          fetched: { $set: true },
          value: { $set: action.response },
        },
      });
    case actions.POST_USER_SIGN_IN_SUCCESS:
      return Object.assign({}, state, {
        AuthLog: action.Status,
      });
    case actions.GET_USER_IDENTITY_SUCCESS:
      return update(state, {
        Identity: { $set: action.response },
      });
    default:
      return state;
  }
};

export default twoStepAuthenticationReducer;
